export default __webpack_public_path__ + "static/media/material-ui_nereus.24ff9e63.svg";